export default __webpack_public_path__ + "static/media/distance-radius.116702ff.svg";